var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tilt",rawName:"v-tilt",value:({
    speed: 500,
    perspective: 1200,
    max: 35,
    scale: 1.05,
  }),expression:"{\n    speed: 500,\n    perspective: 1200,\n    max: 35,\n    scale: 1.05,\n  }"}],staticClass:"tool-card-container"},[_c('div',{staticClass:"tool-image"},[_c('img',{attrs:{"src":require('@/assets/logos/' + _vm.image)}})]),_c('div',{staticClass:"tool-name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }